<div [formGroup]="form" *ngIf="isVisible">
  <form-field
    class="front mb-0 mt-3"
    label="Street Name and Building Number *"
    i18n-label="
      @@support.residentialChangeTicket.streetNameAndBuildingNum.label"
  >
    <input
      required
      type="text"
      formControlName="street"
      placeholder="Fill out the street name and building number"
      i18n-placeholder="
        @@support.residentialChangeTicket.streetNameAndBuildingNum.placeholder"
    />
  </form-field>
  <small
    i18n="@@support.required"
    class="text-danger"
    *ngIf="street?.errors?.required && street?.touched"
    >* This field is required.</small
  >
  <form-field
    class="front mb-0 mt-3"
    label="Postal code"
    i18n-label="@@support.residentialChangeTicket.postalCode.label"
  >
    <input
      type="text"
      formControlName="postalCode"
      placeholder="Fill out the postal code"
      i18n-placeholder="
        @@support.residentialChangeTicket.postalCode.placeholder"
    />
  </form-field>

  <form-field
    class="front mb-0 mt-3"
    label="Area"
    i18n-label="@@support.residentialChangeTicket.area.label"
  >
    <input
      type="text"
      formControlName="area"
      placeholder="Fill out the area"
      i18n-placeholder="@@support.residentialChangeTicket.area.placeholder"
    />
  </form-field>
  <form-field
    class="front mb-0 mt-3"
    label="City *"
    i18n-label="@@support.residentialChangeTicket.city.label"
  >
    <input
      required
      type="text"
      formControlName="city"
      placeholder="Fill out the city"
      i18n-placeholder="@@support.residentialChangeTicket.city.placeholder"
    />
  </form-field>
  <small
    i18n="@@support.required"
    class="text-danger"
    *ngIf="city?.errors?.required && city?.touched"
    >* This field is required.</small
  >

  <form-field
    class="front mb-0 mt-3"
    label="Country *"
    i18n-label="@@support.residentialChangeTicket.country.label"
  >
    <input
      required
      type="text"
      formControlName="country"
      placeholder="Fill out the country"
      i18n-placeholder="@@support.residentialChangeTicket.country.placeholder"
    />
  </form-field>

  <small
    i18n="@@support.required"
    class="text-danger"
    *ngIf="country?.errors?.required && country?.touched"
    >* This field is required.</small
  >
  <file-uploader
    [maxSize]="1024 * 5"
    [allowedTypes]="['pdf']"
    (select)="onFileSelect($event)"
    (remove)="onFileRemove()"
    class="d-block w-100 mb-0 mt-3"
  >
    <input
      #file
      type="file"
      class="input"
      (click)="markAsTouched('proofOfAddressDocument')"
      required
    />
    <ng-template #placeholder>
      <img
        src="assets/images/icons/upload-document.svg"
        alt="upload document icon"
      />
      <div
        class="text-primary pt-2 text-sm"
        i18n="@@support.residentialChangeTicket.proofOfAddressDocument"
      >
        Proof of address document *
      </div>
    </ng-template>
  </file-uploader>

  <small
    i18n="@@support.required"
    class="text-danger"
    *ngIf="
      proofOfAddressDocument?.errors?.required &&
      proofOfAddressDocument?.touched
    "
    >* This field is required.</small
  >
  <form-field
    class="front textarea mb-0 mt-3"
    label="Ticket Message"
    i18n-label="@@support.message.label"
  >
    <textarea
      formControlName="message"
      placeholder="Enter your ticket message"
      rows="5"
      i18n-placeholder="@@support.message.placeholder"
    ></textarea>
  </form-field>
</div>
